"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSystemCourseMock = exports.getSystemCoursesMock = void 0;
exports.getSystemCoursesMock = {
    courses: [
        {
            uuid: 'f3e1b3db-e0a8-42cf-b651-667c3bbd458d',
            displayName: 'course1 display name',
            description: 'course1 description',
            tagline: 'course1 tagline',
            iconUrl: 'https://picsum.photos/200/300?random=1',
            active: true,
            activeOnLean: false,
            publishedAt: new Date(),
            updatedAt: new Date(),
            lessons: [
                {
                    uuid: '6416ff4c3eda9a750310e194',
                    position: 1,
                    name: 'name',
                    displayName: 'display name',
                    iconUrl: 'https://picsum.photos/200/300?random=1',
                    active: false,
                    duration: '5-8',
                    publishedAt: null,
                },
                {
                    uuid: '64170948f5794011b4a489cf',
                    position: 2,
                    name: 'name',
                    displayName: 'display name',
                    iconUrl: 'https://picsum.photos/200/300?random=1',
                    active: true,
                    duration: '5-8',
                    publishedAt: new Date(),
                },
            ],
        },
        {
            uuid: 'f3e1b3db-e0a8-42cf-b651-667c3bbd458c',
            displayName: 'course2 display name',
            description: 'course2 description',
            tagline: 'course2 tagline',
            iconUrl: 'https://picsum.photos/200/300?random=1',
            active: true,
            activeOnLean: false,
            publishedAt: new Date(),
            updatedAt: new Date(),
            lessons: [
                {
                    uuid: '6416ff4c3eda9a750310e193',
                    position: 1,
                    name: 'name',
                    displayName: 'display name',
                    iconUrl: 'https://picsum.photos/200/300?random=1',
                    active: false,
                    duration: '5-8',
                    publishedAt: null,
                },
                {
                    uuid: '64170948f5794011b4a489cr',
                    position: 2,
                    name: 'name',
                    displayName: 'display name',
                    iconUrl: 'https://picsum.photos/200/300?random=1',
                    active: true,
                    duration: '5-8',
                    publishedAt: new Date(),
                },
            ],
        },
        {
            uuid: 'f3e1b3db-e0a8-42cf-b651-667c3bbd458c',
            displayName: 'course3 display name',
            description: 'course3 description',
            tagline: 'course3 tagline',
            iconUrl: 'https://picsum.photos/200/300?random=1',
            active: true,
            activeOnLean: false,
            publishedAt: new Date(),
            updatedAt: new Date(),
            lessons: [
                {
                    uuid: '6416ff4c3eda9a750310e193',
                    position: 1,
                    name: 'name',
                    displayName: 'display name',
                    iconUrl: 'https://picsum.photos/200/300?random=1',
                    active: true,
                    duration: '5-8',
                    publishedAt: new Date(),
                },
                {
                    uuid: '64170948f5794011b4a489cr',
                    position: 2,
                    name: 'name',
                    displayName: 'display name',
                    iconUrl: 'https://picsum.photos/200/300?random=1',
                    active: false,
                    duration: '5-8',
                    publishedAt: null,
                },
            ],
        },
    ],
};
exports.getSystemCourseMock = {
    course: {
        uuid: 'f3e1b3db-e0a8-42cf-b651-667c3bbd458d',
        displayName: 'course1 display name',
        description: 'course1 description',
        tagline: 'course1 tagline',
        iconUrl: 'https://picsum.photos/200/300?random=1',
        active: true,
        activeOnLean: false,
        publishedAt: new Date(),
        updatedAt: new Date(),
    },
    units: [
        {
            unitName: 'Intro',
            unitLessons: ['633eb5a2987aa842d93130f5'],
        },
        {
            unitName: 'summary',
            unitLessons: ['6167f2038df8878a7376a554'],
        },
    ],
    lessons: [
        {
            uuid: '633eb5a2987aa842d93130f5',
            position: 1,
        },
        {
            uuid: '6167f2038df8878a7376a554',
            position: 2,
        },
    ],
};
